<template>
  <div>
    <noscript
      ><iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-WKG9TGV"
        height="0"
        width="0"
        style="display:none;visibility:hidden"
      ></iframe
    ></noscript>
    <div class="container-fluid px-0">
      <div class="d-flex flex-column flex-lg-row">
        <div class="order-2 order-lg-1 col-lg-7 px-0 bg-bee">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="thanks">
                  <div class="text-center">
                    <a href="/">
                      <img
                        class="thanks__logo"
                        src="../assets/images/ap8logo.svg"
                        alt
                      />
                    </a>
                  </div>
                  <h1 class="thanks__headline">
                    Jesteś super! Dziękujemy, że pomagasz pszczołom!
                  </h1>
                  <div class="thanks__content">
                    Dołączasz do grona prawdziwych Pszczelich Bohaterów
                    i&nbsp;Bohaterek!<br />
                    W podziękowaniu po zakończeniu akcji otrzymasz od nas Pakiet
                    Pszczelego Bohatera / Bohaterki - pszczele maseczki,
                    certyfikat, kalendarz z&nbsp;pięknymi ilustracjami zapylaczy
                    oraz ebook o tematyce przyrodniczej.
                  </div>
                  <div class="thanks__share py-4">
                    Udostępnij stronę:
                  </div>
                  <div class="d-flex justify-content-center">
                    <a
                      href="https://www.facebook.com/sharer/sharer.php?u=https%3A//adoptujpszczole.pl/?fundraiser=ap8tpfb"
                    >
                      <img
                        class="thanks__sm"
                        src="../assets/images/fb.png"
                        alt="Udostępnij na Facebook"
                    /></a>
                    <a
                      href="https://twitter.com/intent/tweet?url=&text=Zr%C3%B3bmy%20razem%20co%C5%9B%20ekstra%20dla%20pszcz%C3%B3%C5%82%2C%20motyli%20i%20innych%20zapylaczy!%20Tw%C3%B3rzmy%20Polsk%C4%99%2C%20w%20kt%C3%B3rej%20mog%C4%85%20bezpiecznie%20%C5%BCy%C4%87%20i%20pracowa%C4%87%20dla%20naszego%20wsp%C3%B3lnego%20dobra%3A%20https%3A%2F%2Fact.gp%2Fadoptujtt%20%23adoptujpszczole"
                    >
                      <img
                        class="thanks__sm"
                        src="../assets/images/tt.png"
                        alt="Udostępnij na Twitterze"
                    /></a>
                  </div>
                </div>
              </div>
            </div>
            <FooterGrass />
          </div>
        </div>
        <div class="order-1 order-lg-1 col-lg-5 px-0">
          <video
            class="form__video d-none d-lg-block"
            autoplay
            loop
            muted
            src="../assets/video/trzmiel.mp4"
          ></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FooterGrass from "@/components/FooterGrass.vue";
export default {
  name: "Thanks",
  data() {
    return {
      title: "Thanks",
    };
  },
  components: {
    FooterGrass,
  },
  mounted() {

    let fbScript = document.createElement("script");
    fbScript.text = `
      let purchaseAmount = new URLSearchParams(location.search).get("a");
      let eventId = new URLSearchParams(location.search).get("p");
      fbq('track', 'Purchase', {
        value: purchaseAmount,
        currency: 'PLN'
      }, {eventID: eventId });
    `;
    document.body.appendChild(fbScript);

    let gtmScript = document.createElement("script");

    gtmScript.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-WKG9TGV');`;

    document.body.appendChild(gtmScript);

    let gtmScript2 = document.createElement("script");

    gtmScript2.text = `let amount = new URLSearchParams(location.search).get("a");
  let paymentId = new URLSearchParams(location.search).get("p");;
  dataLayer.push({
    "event": "transactionSuccess",
    "ecommerce": {
      "currencyCode": "PLN",
      "purchase": {
        "actionField": {
          "id": paymentId,
          "affiliation": "ap8",
          "revenue": amount,
          "action": "purchase"
        },
        "products": [
          {
            "name": "ap8",
            "id": "45",
            "price": amount,
            "brand": "GPPL",
            "quantity": "1"
          }
        ]
      }
    },
    "officeName": "Poland",
    "gBasket": "Good Life",
    "gScope": "Local",
    "gLocalCampaign": "ap8",
    "gLocalPlatform": "Goddess",
    "gAmount": amount,
    "gPageName": "ap8",
    "gPagetype": "Donation",
    "NewsletterSignup": "Y",
    "recurring": 1,
  });
  `;
    gtmScript2.setAttribute("defer", "");
    document.body.appendChild(gtmScript2);
  },
};
</script>
